<app-header></app-header>

<div class="relative">
    <div class="container flex">
        <div class="flex-1 pt-[100px]">
            <router-outlet></router-outlet>
        </div>
        <div class="flex-1">&nbsp;</div>
    </div>
    <div class="flex absolute inset-0 z-[-1]">
        <div class="flex-1">&nbsp;</div>
        <div class="flex-1">
            <app-auth-hero></app-auth-hero>
        </div>
    </div>
</div>
